import { Reducer } from "redux";
import { FormTypes } from "utilities/interfaces/IForm";
import { InitialFormAction } from "./formActions";
import formTypes from "./formTypes";

const INITIAL_STATE = {
  hasValue: false,
};

const FormReducer: Reducer<FormTypes, InitialFormAction> = (
  state: FormTypes = { ...INITIAL_STATE },
  action
) => {
  switch (action.type) {
    case formTypes.Form_Has_value:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};

export default FormReducer